import React from 'react';

import { useNavigate } from 'react-router-dom';
import { ONLINE_SALES_URL, PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from 'shared/constants';
import { IframeDialog } from 'shared/ui';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="flex w-full shrink-0 items-center justify-center bg-black py-[65px]" id="footer-content">
      <div className="w-full max-w-[1440px] px-6">
        <div className="flex justify-between text-c1">
          <div className="mb-20 flex w-full gap-[120px]">
            <div className="min-w-[180px]">
              <h3 className="mb-2 w-full border-b border-white pb-2 text-white">Intro</h3>
              <ul className="space-y-1 text-gray-30">
                <li>
                  <button
                    type="button"
                    className="border-0 bg-transparent p-0 text-inherit hover:underline"
                    onClick={() => {
                      navigate('/guide');

                      window.dataLayer?.push({
                        event: 'click_footer',
                        menu: 'Booking Guide',
                        section: 'Intro',
                      });
                    }}
                  >
                    Booking Guide
                  </button>
                </li>

                <li>
                  <a
                    href="https://buttercup-coral-e9a.notion.site/About-CheckmateKorea-1e4c00e5608680048c69fe0ac3b7da11?pvs=4"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:underline"
                    onClick={() => {
                      window.dataLayer?.push({
                        event: 'click_footer',
                        menu: 'About CheckmateKorea',
                        section: 'Intro',
                      });
                    }}
                  >
                    About CheckmateKorea
                  </a>
                </li>
                <li>
                  <a
                    href="https://buttercup-coral-e9a.notion.site/Why-CheckmateKorea-1e4c00e56086806599eefb938f144389?pvs=4"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:underline"
                    onClick={() => {
                      window.dataLayer?.push({
                        event: 'click_footer',
                        menu: 'Why CheckmateKorea',
                        section: 'Intro',
                      });
                    }}
                  >
                    Why CheckmateKorea
                  </a>
                </li>
                <li>
                  <a
                    href="https://buttercup-coral-e9a.notion.site/Korean-Housing-Info-1e6c00e5608680438572ff3e31a2c988?pvs=4"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:underline"
                    onClick={() => {
                      window.dataLayer?.push({
                        event: 'click_footer',
                        menu: 'Korean Housing Info',
                        section: 'Intro',
                      });
                    }}
                  >
                    Korean Housing Info
                  </a>
                </li>
              </ul>
            </div>

            <div className="min-w-[500px]">
              <h3 className="mb-2 w-full border-b border-white pb-2 text-white">All Services</h3>
              <ul className="grid grid-cols-[1fr,minmax(0,120px)] gap-x-20 gap-y-1 pr-5 text-gray-30">
                <li>
                  <button
                    type="button"
                    className="border-0 bg-transparent p-0 text-inherit hover:underline"
                    onClick={() => {
                      navigate('/listing?roomTypes=STUDIO%2CSHAREHOUSE%2COFFICETEL%2COTHERS');

                      window.dataLayer?.push({
                        event: 'click_footer',
                        menu: 'Room Search',
                        section: 'All Services',
                      });
                    }}
                  >
                    Room Search
                  </button>
                </li>

                <li>
                  <a
                    href="https://buttercup-coral-e9a.notion.site/Checkmate-Membership-1d8c00e5608680c4b530ea0b86e3fff8"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:underline"
                    onClick={() => {
                      window.dataLayer?.push({
                        event: 'click_footer',
                        menu: 'Membership',
                        section: 'All Services',
                      });
                    }}
                  >
                    Membership
                  </a>
                </li>

                <li>
                  <IframeDialog title="Request a Room" src="https://tally.so/r/w8JzGx">
                    <button
                      type="button"
                      className="border-0 bg-transparent p-0 text-inherit hover:underline"
                      onClick={() => {
                        window.dataLayer?.push({
                          event: 'click_footer',
                          menu: ' Request a Room that meets your criteria',
                          section: 'All Services',
                        });
                      }}
                    >
                      Request a Room that meets your criteria
                    </button>
                  </IframeDialog>
                </li>

                <li>
                  <a
                    href="https://buttercup-coral-e9a.notion.site/Checkmate-Plus-1d3c00e5608680b4868ef5d3f5155bdf"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:underline"
                    onClick={() => {
                      window.dataLayer?.push({
                        event: 'click_footer',
                        menu: 'Checkmate Plus',
                        section: 'All Services',
                      });
                    }}
                  >
                    Checkmate Plus
                  </a>
                </li>

                <li>
                  <IframeDialog title="Check With You" src="https://tally.so/r/w5EgKZ">
                    <button
                      type="button"
                      className="border-0 bg-transparent p-0 text-inherit hover:underline"
                      onClick={() => {
                        window.dataLayer?.push({
                          event: 'click_footer',
                          menu: 'Check With You',
                          section: 'All Services',
                        });
                      }}
                    >
                      Check With You
                    </button>
                  </IframeDialog>
                </li>

                <li></li>

                <li>
                  <IframeDialog title="Contract Signing Accompaniment" src="https://tally.so/r/mV4pR6">
                    <button
                      type="button"
                      className="border-0 bg-transparent p-0 text-inherit hover:underline"
                      onClick={() => {
                        window.dataLayer?.push({
                          event: 'click_footer',
                          menu: 'Contract Signing Accompaniment',
                          section: 'All Services',
                        });
                      }}
                    >
                      Contract Signing Accompaniment
                    </button>
                  </IframeDialog>
                </li>

                <li></li>
              </ul>
            </div>

            <div className="min-w-[180px]">
              <h3 className="mb-2 w-full border-b border-white pb-2 text-white">Find Out More</h3>
              <ul className="space-y-1 text-gray-30">
                <li>
                  <a
                    href="https://buttercup-coral-e9a.notion.site/Reviews-3f709f03cdf6445983d0204f1eb430f3?pvs=4"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:underline"
                    onClick={() => {
                      window.dataLayer?.push({
                        event: 'click_footer',
                        menu: 'Reviews',
                        section: 'Find Out More',
                      });
                    }}
                  >
                    Reviews
                  </a>
                </li>
                <li>
                  <button
                    type="button"
                    className="border-0 bg-transparent p-0 text-inherit hover:underline"
                    onClick={() => {
                      navigate('/blog');

                      window.dataLayer?.push({
                        event: 'click_footer',
                        menu: 'Blog',
                        section: 'Find Out More',
                      });
                    }}
                  >
                    Blog
                  </button>
                </li>
                <li>
                  <a
                    href="https://buttercup-coral-e9a.notion.site/Help-Center-a65dec1c44ca44958a2d192d5119017e?pvs=4"
                    target="_blank"
                    rel="noreferrer"
                    className="hover:underline"
                    onClick={() => {
                      window.dataLayer?.push({
                        event: 'click_footer',
                        menu: 'Help Center',
                        section: 'Find Out More',
                      });
                    }}
                  >
                    Help Center
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="ml-20 flex flex-shrink-0 flex-col items-end space-y-1 text-gray-200">
            <a
              href="https://admin.checkmatekorea.com/login"
              className="flex items-center gap-1 hover:underline"
              onClick={() => {
                window.dataLayer?.push({
                  event: 'click_footer',
                  menu: '무료로 방 등록하기',
                  section: 'business  ',
                });
              }}
              target="_blank"
              rel="noreferrer"
            >
              무료로 방 등록하기 <span aria-hidden>↗</span>
            </a>
            <a
              href="https://tally.so/r/w8xaax"
              className="flex items-center gap-1 hover:underline"
              onClick={() => {
                window.dataLayer?.push({
                  event: 'click_footer',
                  menu: '제휴협력 제안하기',
                  section: 'business  ',
                });
              }}
              target="_blank"
              rel="noreferrer"
            >
              제휴협력 제안하기 <span aria-hidden>↗</span>
            </a>
            <a
              href="https://housebuddy.oopy.io/"
              className="flex items-center gap-1 hover:underline"
              onClick={() => {
                window.dataLayer?.push({
                  event: 'click_footer',
                  menu: '회사 소개',
                  section: 'business',
                });
              }}
              target="_blank"
              rel="noreferrer"
            >
              회사 소개 <span aria-hidden>↗</span>
            </a>
          </div>
        </div>

        <p className="text-c4 text-gray-70">
          <span>상호명 (주)하우스버디 | 대표자 임지은 | 개인정보책임자 임지은 | 사업자 등록번호 586-87-03123 | </span>
          <a
            className="cursor-pointer underline-offset-2 hover:underline"
            href={ONLINE_SALES_URL}
            target="_blank"
            rel="noreferrer"
          >
            통신판매업신고번호: 2024-서울동작-0725
          </a>
          <br />
          <span>서울특별시 동대문구 경희대로 26 2층 203호 (경희대학교삼의원창업센터, 회기동)</span>
          <br />
          <a
            className="cursor-pointer underline-offset-2 hover:underline"
            href={TERMS_OF_SERVICE_URL}
            target="_blank"
            rel="noreferrer"
          >
            이용약관
          </a>
          <span> | </span>
          <a
            className="cursor-pointer underline-offset-2 hover:underline"
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noreferrer"
          >
            개인정보처리방침
          </a>
          <span> | 고객지원: official@checkmatekorea.com | 고객센터: 010-8703-3395</span>
          <br />
          <span>{'{에스크로인증마크}'}</span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
